module.exports = __webpack_public_path__ + "img/arrow-right-bar-right.a407337d.svg";